export const QUERY_KEYS = {
  CREATE_REGISTRATION: "CREATE_REGISTRATION",
  DELETE_REGISTRATION: "DELETE_REGISTRATION",
  GET_REGISTRATIONS: "GET_REGISTRATIONS",
};
